import { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { setDocumentTitle } from '../../util';
import type { WhiteLabelGoogleTagProvider } from '../../hooks/useWhiteLabelGoogleTag/useWhiteLabelGoogleTag';
import { getAxisPageTitle } from './AxisConstants';

export const useAxisPageMetadata = ({
  active,
  analytics,
}: {
  active: boolean;
  analytics?: WhiteLabelGoogleTagProvider;
}) => {
  const location = useLocation();
  const triggerPageView = analytics?.triggerPageView;

  useEffect(() => {
    if (!active) {
      return;
    }

    const title = getAxisPageTitle(location.pathname);
    setDocumentTitle(title);
    triggerPageView?.(title, `${location.pathname}${location.search}`);
  }, [active, location.pathname, location.search, triggerPageView]);
};
